import { Components } from 'formiojs';
import FieldComponent from 'formiojs/components/_classes/field/Field';

export class TimerComponent extends FieldComponent {
  timer: any = null;
  startTime: number = 0;
  elapsedTime: number = 0; // in ms
  running: boolean = false;
    addEventListener: any;
    refs: any;
    setValue: any;

  static schema(...extend: any[]) {
    return FieldComponent.schema(
      {
        type: 'timer',
        label: 'Timer',
        key: 'timer',
        input: true,
      },
      ...extend
    );
  }

  static builderInfo = {
    title: 'Timer',
    group: 'basic',
    icon: 'clock',
    weight: 80,
    schema: TimerComponent.schema(),
  };

  render(children: any) {
    return super.render(`
      <div class="timer-container">
        <div ref="display" class="timer-display">00:00:00</div>
        <div class="mt-2">
          <button ref="startBtn" class="btn btn-success btn-sm">Start</button>
          <button ref="stopBtn" class="btn btn-warning btn-sm">Stop</button>
          <button ref="resetBtn" class="btn btn-danger btn-sm">Reset</button>
        </div>
      </div>
    `);
  }

  attach(element: any) {
    const refs = super.attach(element);

    if (this.refs.startBtn) {
      this.addEventListener(this.refs.startBtn, 'click', () => this.startTimer());
    }
    if (this.refs.stopBtn) {
      this.addEventListener(this.refs.stopBtn, 'click', () => this.stopTimer());
    }
    if (this.refs.resetBtn) {
      this.addEventListener(this.refs.resetBtn, 'click', () => this.resetTimer());
    }

    return refs;
  }

  startTimer() {
    if (!this.running) {
      this.running = true;
      this.startTime = Date.now() - this.elapsedTime;

      this.timer = setInterval(() => {
        this.elapsedTime = Date.now() - this.startTime;
        this.updateDisplay();
      }, 1000);
    }
  }

  stopTimer() {
    if (this.running) {
      clearInterval(this.timer);
      this.running = false;
      this.setValue(this.formatTime(this.elapsedTime)); // Save value
    }
  }

  resetTimer() {
    clearInterval(this.timer);
    this.running = false;
    this.elapsedTime = 0;
    this.updateDisplay();
    this.setValue('00:00:00');
  }

  updateDisplay() {
    if (this.refs.display) {
      this.refs.display.innerHTML = this.formatTime(this.elapsedTime);
    }
  }

  formatTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }
}

Components.addComponent('timer', TimerComponent);
